import { HTTP } from '../services';
import { GetURLRequestAccess } from '../config';

class UserRequestAccess {

    async getUserRequestAccess(appName) {
        try {
            const URL =`generic/user-request-access-fetch-by-user-id?application-name=${appName}`;
            const response = await HTTP.GET( GetURLRequestAccess(URL));
            return (response && response.responseListObject) || [];
        }
        catch (e) {
            console.error('Error:', e.toString());
        }
    }

    generateReqObj (data, group) {
        return( {
            action: data.action,
            applicationName: data.appName,
            environmentType: data.environmentType,
            requestedAccessType: data.request_access,
            requestedCountryCode: data.market_list,
            requestedGroup:data.requestedGroup,// group
            requestedRole: data.roles,
            createdBy:data.createdBy // 'KNHN999'//
        })
    } 
    modifyRequest (data) {
        let request = []//[this.generateReqObj(data[0], 'grp_test2'), this.generateReqObj(data[0], 'grp_test3')];
        if( data && Array.isArray(data)) {
            request = data.map(obj => this.generateReqObj(obj));
        }
        return request;
    }
    
    async saveOrUpdateUserRequestAccess(request) {
        try {
            let URL = `generic/user-request-access`
            const response = await HTTP.POST(GetURLRequestAccess(URL), this.modifyRequest(request));
            return (response);
        }
        catch (e) {
            console.error('Error:', e.toString());
        }
    }

}

export const requestAccessServices = new UserRequestAccess();